import {USPsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {IsomorphicScript} from '@aboutyou/head-elements';
import {InfiniteSlider, Usp} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {fnQuickViewUspsDisplayCorrectionScript} from './QuickViewUspsDisplayCorrectionSnippet';

export const QUICK_VIEW_USPS_AND_BEST_PRICE_GUARANTEE_QUERY_PARAM = 'ub';

export const QuickViewUSPsView: React.FC<USPsSection> = ({usps}) => {
  const uspsMappedToUrlParam = {
    // 1 is the usp slider and its rendered separately
    '2': usps[2], // invoice payment usp
    '3': usps[0], // free delivery usp
    '4': usps[1], // return period usp
  };

  /**
   * The visibility of the versions of USP is entirely controlled by css variables injected by script in `QuickViewUspsDisplayCorrectionSnippet.js`.
   * This is because we cannot rely on the urlParams (using useQueryParams) to control the visibility of the USPs, because the urls params are ignored in the caching on a ADP in CF.
   * As such the page served by CF was cached independent of this url param `ub`.
   * To correctly display the USPs we need to render all variants on the server and then hide the ones that are not needed on the client using css variables via script injected in `QuickViewUspsDisplayCorrectionSnippet.js`.
   */
  return (
    <>
      <IsomorphicScript
        id="QuickViewUspsDisplayCorrectionSnippet"
        content={`(${fnQuickViewUspsDisplayCorrectionScript.toString()})("${QUICK_VIEW_USPS_AND_BEST_PRICE_GUARANTEE_QUERY_PARAM}")`}
      />
      <DisplayCorrectionWrapper
        $urlParamValue={'var(--quick-view-usp-banner-1, block)'}
        data-testid="quick-view-usp-banner-1"
      >
        <InfiniteSlider
          items={usps}
          SlideComponent={({item: usp}) => (
            <StyledUsp
              key={usp.label}
              text={usp.label}
              image={{
                description: usp.image.description,
                url: `${usp.image.url}&transparent=1`,
              }}
              href={usp.href}
            />
          )}
        />
      </DisplayCorrectionWrapper>

      {Object.entries(uspsMappedToUrlParam).map(
        ([urlParamValue, usp]) =>
          usp && (
            <DisplayCorrectionWrapper
              key={urlParamValue}
              $urlParamValue={`var(--quick-view-usp-banner-${urlParamValue}, block)`}
              data-testid={`quick-view-usp-banner-${urlParamValue}`}
            >
              <StyledUsp
                key={usp.label}
                text={usp.label}
                image={{
                  description: usp.image.description,
                  url: `${usp.image.url}&transparent=1`,
                }}
                href={usp.href}
              />
            </DisplayCorrectionWrapper>
          ),
      )}
    </>
  );
};

const DisplayCorrectionWrapper = styled.div<{$urlParamValue: string}>`
  display: ${props => props.$urlParamValue};
`;

const StyledUsp = styled(Usp)`
  &&& {
    justify-content: center;
    flex-shrink: 0;
    flex-basis: calc(100%);
    padding: 10px 0;
    img {
      scale: 1.1;
    }
  }
`;
